var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollabsDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Campaigns") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8.-V3-Finance-dashboard---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Financing_Daashboard-DEMO",
    transform: "translate(-406.000000, -581.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(406.000000, 581.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network",
    transform: "translate(0.666667, 0.708333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63666667,12.1025833 L3.47466667,13.09 C2.98466667,13.3138333 2.66666667,13.8259583 2.66666667,14.392625 L2.66666667,15.5833333 L12,15.5833333 L12,14.392625 C12,13.8259583 11.682,13.3138333 11.192,13.0907083 L9.02466667,12.1075417",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeLinecap: "square",
    cx: 7.33333333,
    cy: 1.41666667,
    rx: 1.33333333,
    ry: 1.41666667
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeLinecap: "square",
    cx: 13.3333333,
    cy: 4.95833333,
    rx: 1.33333333,
    ry: 1.41666667
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeLinecap: "square",
    cx: 1.33333333,
    cy: 4.95833333,
    rx: 1.33333333,
    ry: 1.41666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,12.75 L7.33333333,12.75 C5.86066667,12.75 4.66666667,11.481375 4.66666667,9.91666667 L4.66666667,9.20833333 C4.66666667,7.643625 5.86066667,6.375 7.33333333,6.375 L7.33333333,6.375 C8.806,6.375 10,7.643625 10,9.20833333 L10,9.91666667 C10,11.481375 8.806,12.75 7.33333333,12.75 Z",
    id: "Path",
    strokeLinecap: "square"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabsDark);
export default __webpack_public_path__ + "static/media/collabs_dark.22d44c24ef3d622420f2a737463239c4.svg";
export { ForwardRef as ReactComponent };